import { Controller } from "@hotwired/stimulus"

// 어드민 테이블 헤더의 엑셀식 필터 드롭다운 — 한 번에 하나만 열림, 외부클릭/ESC 로 닫힘.
//
// 드롭다운(absolute)은 조상 테이블 래퍼(.overflow-x-auto)안에 있다. CSS 상 overflow-x:auto 는
// overflow-y 도 auto 로 강제하므로, 행이 적은 화면에서는 래퍼 높이가 짧아 드롭다운 하단이 잘리고
// 래퍼 안에 내부 스크롤이 생긴다. 드롭다운이 열려있는 동안만 래퍼의 overflow 를 visible 로 풀어
// 잘리지 않게 하고, 닫히면 정확히 원복한다(가로 스크롤이 필요한 넓은 테이블 보존) — 리뷰 지적 I-4.
export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
    this.outside = (e) => { if (!this.element.contains(e.target)) this.closeAll() }
    this.escape = (e) => { if (e.key === "Escape") this.closeAll() }
    document.addEventListener("click", this.outside)
    document.addEventListener("keydown", this.escape)
    this.wrapper = this.element.closest(".overflow-x-auto")
  }

  disconnect() {
    document.removeEventListener("click", this.outside)
    document.removeEventListener("keydown", this.escape)
    this.restoreWrapper()
  }

  // 대상 드롭다운만 토글, 나머지는 닫기 (한 번에 하나만 열림)
  toggle(event) {
    event.stopPropagation()
    const key = event.params.key
    const target = this.dropdownTargets.find((el) => el.dataset.key === key)
    const willOpen = target && target.classList.contains("hidden")
    this.closeAll()
    if (willOpen) {
      target.classList.remove("hidden")
      this.freeWrapper()
    }
  }

  closeAll() {
    this.dropdownTargets.forEach((el) => el.classList.add("hidden"))
    this.restoreWrapper()
  }

  // 래퍼 overflow 를 visible 로 풀어 드롭다운이 잘리지 않게 한다
  freeWrapper() {
    if (!this.wrapper) return
    this.wrapper.style.overflow = "visible"
  }

  // 래퍼 overflow 를 원복 — 인라인 스타일 제거로 CSS 클래스(overflow-x-auto)가 다시 적용된다
  restoreWrapper() {
    if (!this.wrapper) return
    this.wrapper.style.removeProperty("overflow")
  }
}
